import { Car, Route, Settings2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { EXPENSES_MANAGE, holds, useExpensesPermissions } from '../use-expenses-permissions';

/**
 * The list's mileage entries (release 3): «Nuovo viaggio» and the person's «Veicoli» and
 * «Percorsi usuali»; Gestione also sees the mileage settings. Secondary buttons: the page's one
 * primary stays «Nuova spesa».
 */
export function MileageLinks({ canCreate }: { readonly canCreate: boolean }) {
  const { t } = useTranslation('expenses');
  const manages = holds(useExpensesPermissions(), EXPENSES_MANAGE);
  return (
    <nav aria-label={t('mileage.links.label')} className="flex flex-wrap gap-2">
      {canCreate ? (
        <Button asChild variant="outline" size="sm">
          <Link to="/expenses/trips/new">
            <Car />
            {t('mileage.links.newTrip')}
          </Link>
        </Button>
      ) : null}
      {canCreate ? (
        <Button asChild variant="ghost" size="sm">
          <Link to="/expenses/vehicles">{t('mileage.links.vehicles')}</Link>
        </Button>
      ) : null}
      {canCreate ? (
        <Button asChild variant="ghost" size="sm">
          <Link to="/expenses/routes">
            <Route />
            {t('mileage.links.routes')}
          </Link>
        </Button>
      ) : null}
      {manages ? (
        <Button asChild variant="ghost" size="sm">
          <Link to="/expenses/settings/mileage">
            <Settings2 />
            {t('mileage.links.settings')}
          </Link>
        </Button>
      ) : null}
    </nav>
  );
}
